import React from 'react';
import PropTypes from 'prop-types';

const VIEWPORT_HEIGHT_PADDING = 50; // maintain this distance between bottom of container and viewport

export default class OnsiteNotificationsDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.contentNode = null;
    }

    componentDidMount() {
        document.addEventListener('click', this.props.onDocumentClick);
        this.calculateHeight();
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.props.onDocumentClick);
    }

    getViewportHeight() {
        return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }

    calculateHeight() {
        const rect = this.contentNode.getBoundingClientRect();
        const diff = this.getViewportHeight() - rect.bottom - VIEWPORT_HEIGHT_PADDING;

        if (diff < 0) {
            this.props.onViewportHeightAdjustment(diff);
        }
    }

    render() {
        return (
            <div
                className="onsite-notifications__dropdown"
                ref={n => this.contentNode = n}
            >
                {this.props.children}
                <div className="onsite-notifications__tip" />
            </div>
        );
    }
}

OnsiteNotificationsDropdown.propTypes = {
    onViewportHeightAdjustment: PropTypes.func,
    onDocumentClick: PropTypes.func,
    children: PropTypes.node.isRequired,
};

OnsiteNotificationsDropdown.defaultProps = {
    onViewportHeightAdjustment() {},
    onDocumentClick() {},
};



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/src/components/onsite-notifications-dropdown.jsx